<template>
  <button
    class="research-directions-questions-pill d-flex v-btn v-size--default focused--text px-4 py-1 mt-1"
    :aria-label="activatorLabel"
    @click="$emit('click')"
    @blur="$emit('blur')"
    @keydown.esc="$emit('blur')"
  >
    <ResearchDirectionsQuestionMarkIcon
      id="researchDirectionsIconTooltipButton"
      class="mr-2"
    />
    <span>Research Questions</span>
    <v-icon class="focused--text">{{ mdiChevronRight }}</v-icon>
  </button>
</template>

<script>
import { mdiChevronRight } from "@mdi/js";
import ResearchDirectionsQuestionMarkIcon from "~/components/research-directions/icons/ResearchDirectionsQuestionMarkIcon.vue";

export default {
  name: "ResearchDirectionsQuestionToggletipButton",
  components: { ResearchDirectionsQuestionMarkIcon },
  props: {
    activatorLabel: { type: String, default: "more info" },
  },
  data() {
    return {
      // Icon
      mdiChevronRight,
    };
  },
};
</script>

<style scoped>
.research-directions-questions-pill {
  border-radius: 40px;
  border: solid 1px var(--v-brighter-base);
  background-color: var(--v-inverted-base) !important;
  box-shadow: none;

  width: fit-content;
  cursor: pointer;
}
</style>
